var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cves-score-table-cell"},[(_vm.versionExist)?_c('span',{staticClass:"amount",on:{"click":function($event){return _vm.toggleCVEsListPopup(_vm.item)}}},[_vm._v(_vm._s(_vm.cvesAmount))]):_c('span',{staticClass:"material-icons-outlined"},[_vm._v(" remove ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }